$(document).ready(function() {
  $('#dependentInputId').on('input', function() {
    $('#dependentOutputId').text($(this).val());
  });
});
